import {useState} from "react";
import SearchIcon from "../../data/Icons/leon-inmobiliaria-icons-suche-filter.svg";
import {useRouter} from "next/router";
import {useTranslation} from "next-i18next";

interface SearchFieldPropsInterface {
	title: string;
	onChange: (searchVal: string) => void;
	parent?: "vermietung" | "kauf";
	onSubmit: () => void;
	isVermietungMainFilter?: boolean;
}

export default function SearchField(props: SearchFieldPropsInterface) {
	const router = useRouter();
	const {t} = useTranslation();
	const [isSelected, setIsSelected] = useState(false);
	const initialQueryValue = (router.query.id ?? "") as string;
	const [searchValue, setSearchValue] = useState<string>("");

	return (
		<div
			className={`space-y-2 ${props.isVermietungMainFilter ? "" : "h-20"} col-span-1  md:w-auto px-[4px] md:px-0 ${
				props.parent === "vermietung" && "h-20"
			}`}
		>
			<span className="text-[16px] md:text-[20px]">{props.title}:</span>
			<div
				className="relative flex items-center h-[40px]"
				onFocus={() => setIsSelected(true)}
				onBlur={() => setIsSelected(false)}
			>
				<input
					defaultValue={initialQueryValue}
					onChange={(e) => {
						props.onChange(e.target.value);
						setSearchValue(e.target.value);
					}}
					onKeyUp={(event) => {
						// If the user presses the "Enter" key on the keyboard
						if (event.key === "Enter") {
							props.onSubmit();
						}
					}}
					id="search"
					type="search"
					className="w-full h-full input-field"
				/>

				{!isSelected && initialQueryValue == "" && searchValue == "" && (
					<div className="absolute inset-y-0 right-0 flex items-center pr-3.5 pointer-events-none hidden">
						<SearchIcon className="w-6 h-6 text-leo-button-gray"/>
					</div>
				)}
			</div>
		</div>
	);
}
